<script>
    import R, {LOADER} from "../../lib/requests";
    import {createEventDispatcher} from 'svelte/internal';

    export let value = null;
    export let placeholder = "είδος υπηρεσίας";

    let list = [];

    const dispatch = createEventDispatcher();

    const load = (loader = LOADER.PAGE) => {

        const onSuccess = result => {
            list = result;
        }

        const onFailure = err => {
        };

        R.handle(R.ws_service.index, [], onSuccess, onFailure, loader);
    };

    const onChange = event => {

        let item = list.find(x => x.id == event.target.value);
        console.log("onChange", item);
        dispatch("change", item);
    }

    load();
</script>

<select class="form-select" bind:value="{ value }" on:change="{ onChange }">
    <option value="">{ placeholder }</option>
    {#each list as item}
        <option value="{ item.id }">{ item.name }</option>
    {/each}
</select>